import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useSponsorsList() {
  // Use toast
  const toast = useToast()

  const refSponsorsListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    
    { key: 'sponsorType', label: 'Sponsor', sortable: true },
    { key: 'structure', label: 'Structure', sortable: true },
    { key: 'structure', label: 'Adresse', sortable: true },
    { key: 'country', label: 'Pays', sortable: true },
    { key: 'phoneStructure', label: 'Tel structure', sortable: true },
    { key: 'OwnerStandFirstName', label: 'Prenom resp.', sortable: true },
    { key: 'OwnerStandLastName', label: 'Nom resp.', sortable: true },
    { key: 'OwnerStandPhonewhatsapp', label: 'Tel resp.', sortable: true },
    { key: 'OwnerStandEmail', label: 'Email resp.', sortable: true },
    { key: 'desiredPaymentMethod', label: 'Mode de paiement', sortable: true },
    { key: 'status', label: 'Statut', sortable: true },
    { key: 'actions' },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('createdAt')
  const isSortDirDesc = ref(true)

  const dataMeta = computed(() => {
    const localItemsCount = refSponsorsListTable.value ? refSponsorsListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    refSponsorsListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchSponsors = (ctx, callback) => {
    store
      .dispatch('app-sponsors/fetchSponsors', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
      })
      .then(response => {
        
        const sponsors = response.data.data.data;
        callback(sponsors)

        totalUsers.value = response.data.data.total;

      })
      .catch((err) => {
        console.log(err)
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const resolveSponsorStatusVariant = status => {
    if (status === 'PENDING') return 'warning'
    if (status === 'COMPLETED') return 'success'
    if (status === 'CANCELED') return 'danger'
    return 'primary'
  }


  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  return {
    fetchSponsors,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refSponsorsListTable,
    resolveSponsorStatusVariant,
    refetchData
  }
}
